import React from 'react';

export default function Duration({ className, seconds }) {
    const normalizedSeconds = normalizeSeconds(seconds);

    return (
        <time
            dateTime={`P${Math.floor(normalizedSeconds)}S`}
            className={className}
            style={{
                whiteSpace: 'nowrap',
                wordBreak: 'normal',
                overflowWrap: 'normal',
                fontVariantNumeric: 'tabular-nums'
            }}
        >
            {format(normalizedSeconds)}
        </time>
    );
}

function normalizeSeconds(seconds) {
    const numericSeconds = Number(seconds);
    if (!Number.isFinite(numericSeconds) || numericSeconds < 0) {
        return 0;
    }
    return numericSeconds;
}

function format(seconds) {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = pad(date.getUTCSeconds());
    if (hh) {
        return `${hh}:${pad(mm)}:${ss}`;
    }
    return `${mm}:${ss}`;
}

function pad(string) {
    return ('0' + string).slice(-2);
}
